import { LISTEN_MESSAGING_INBOX, MESSAGING_FUNCTIONS, PUSH_REQUESTER_DATA } from '../constants/actionTypes'

const INITIAL_STATE = {
    myInbox: null,
    requesterInfo: null,
    functions: {},
    requesterData: null,
    inboxCounter: 0,
  };



  function messagingReducer(state = INITIAL_STATE, action) {
   
    switch(action.type) {
      case LISTEN_MESSAGING_INBOX : {
          
        return ({
            ...state,
            myInbox: action.payload.myInbox,
            inboxCounter:  action.payload.inboxCounter 
          })
        }
        
        case 'FETCH_REQUESTER_INFO' : { // kann eventuell gelöscht werden
          return ({
              ...state,
              requesterInfo: action.payload  
            })
          }
        case MESSAGING_FUNCTIONS : {
          const { functions } = state
          const functionClone = {...functions}
        
          const newPayload = {...action.payload, ...functionClone}
         
          return ({
            ...state,
            functions: {...newPayload}
          })
        }
        case PUSH_REQUESTER_DATA : {
        
          return({
            ...state,
            requesterData: action.payload
          })
        }

      default : return state;
    }
  }
  
  export default messagingReducer;


// WEBPACK FOOTER //
// ./src/reducers/messaging.js